export default "__VITE_ASSET__CoNnUwIv__"